
import calc_1 from "./calculator/calc-1.jpg"
import calc_2 from "./calculator/calc-2.jpg"
import calc_3 from "./calculator/calc-3.jpg"
import calc_4 from "./calculator/calc-4.jpg"
import calc_5 from "./calculator/calc-5.jpg"
import calc_gif from "./calculator/calc-gif.gif"


import arp_1 from "./arp/arp-1.png" 
import arp_2 from "./arp/arp-2.png"
import arp_3 from "./arp/arp-3.png"
import arp_gif from "./arp/arp-gif.gif"

import sampler_1 from "./sampler/sampler-1.png" 
import sampler_2 from "./sampler/sampler-2.jpg"
import sampler_3 from "./sampler/sampler-3.png"
import sampler_4 from "./sampler/sampler-4.png"

import tri_1 from "./triangle-synth/tri-1.jpg"
import tri_2 from "./triangle-synth/tri-2.jpg"
import tri_3 from "./triangle-synth/tri-3.jpeg"
import tri_4 from "./triangle-synth/tri-4.jpg"
import tri_5 from "./triangle-synth/tri-5.jpeg"
import tri_6 from "./triangle-synth/tri-6.jpeg"

import sub_1 from "./submarine-synth/sub-1.jpg"
import sub_2 from "./submarine-synth/sub-2.jpeg"
import sub_3 from "./submarine-synth/sub-3.jpeg"
import sub_4 from "./submarine-synth/sub-4.jpg"

import dm_1 from "./drone-machines/dm-1.JPG"
import dm_2 from "./drone-machines/dm-2.JPG"
import dm_3 from "./drone-machines/dm-3.JPG"
import dm_4 from "./drone-machines/dm-4.JPG"
import dm_5 from "./drone-machines/dm-5.JPG"
import dm_6 from "./drone-machines/dm-6.jpg"

import clock_1 from "./clock/1.jpeg"
import clock_2 from "./clock/2.jpeg"

import scratch_1 from "./scratch/scratch-1.jpg"
import scratch_2 from "./scratch/scratch-2.jpg"
import scratch_3 from "./scratch/scratch-3.jpg"
import scratch_4 from "./scratch/scratch-4.jpg"
import scratch_5 from "./scratch/scratch-5.jpg"
import scratch_6 from "./scratch/scratch-6.jpg"
import scratch_7 from "./scratch/scratch-7.jpg"

import dabba_1 from "./dabba-synth/dabba-1.jpg"

export const calculator_images = {
    calc_1,
    calc_2,
    calc_3,
    calc_4,
    calc_5,
    calc_gif
}

export const arp_images = {
    arp_1,
    arp_2,
    arp_3,
    arp_gif
}

export const sub_images = {
    sub_1,
    sub_2,
    sub_3,
    sub_4,
}

export const sampler_images = {
    sampler_1,
    sampler_2,
    sampler_3,
    sampler_4
}

export const tri_images = {
    tri_1,
    tri_2,
    tri_3,
    tri_4,
    tri_5,
    tri_6,
}

export const dm_images = {
    dm_1,
    dm_2,
    dm_3,
    dm_4,
    dm_5,
    dm_6
}

export const clock_images = {
    clock_1,
    clock_2
}

export const scratch_images = {
    scratch_1,
    scratch_2,
    scratch_3,
    scratch_4,
    scratch_5,
    scratch_6,
    scratch_7
}

export const dabba_images = {
    dabba_1
}